import React, { Dispatch, SetStateAction } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useTranslation } from "react-i18next";
import makeStyles from "@material-ui/core/styles/makeStyles";
import createStyles from "@material-ui/core/styles/createStyles";
import { Theme, Typography } from "@material-ui/core";
import { getMonth } from "../../helpers/utils";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonBar: {
      padding: `${theme.spacing(3)}px ${theme.spacing(6)}px`,
      display: "flex",
      justifyContent: "center",
      gap: theme.spacing(4),
    },
    dialogTitleBox: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      paddingLeft: "130px",
      paddingRight: "130px",
    },
    dialogTitle: {
      fontWeight: "bold",
      textAlign: "center",
    },
    descriptionText: {
      fontWeight: "bold",
      marginTop: theme.spacing(2),
      marginLeft: theme.spacing(6),
      marginRight: theme.spacing(6),
      lineHeight: "1.1rem",
      fontSize: 14,
    },
    dialogButtons: {
      width: "120px",
      height: "35px",
    },
  })
);

export const RecommendationWarningDialog = (props: iProps) => {
  /* ---- Hooks ---- */
  const classes = useStyles();
  const { t } = useTranslation();
  const { toggle, onClose } = props;

  const formattedReportDate =
    props.reportDate.getFullYear() +
    " " +
    getMonth(props.reportDate.getMonth(), props.userLanguage);

  const handleSubmit = () => {
    onClose();
    props.setDialogOpen(true);
  };

  const closeDialog = () => {
    onClose();
  };

  return (
    <div>
      <Dialog
        open={toggle}
        onClose={closeDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
      >
        <DialogTitle className={classes.dialogTitleBox} id="alert-dialog-title">
          <Typography className={classes.dialogTitle}>
            {t("recommendation_title")}
          </Typography>
        </DialogTitle>
        <Typography
          id="alert-dialog-description"
          className={classes.descriptionText}
        >
          {t("recommendation_warning_1", {
            report_date: formattedReportDate,
          })}
        </Typography>
        <Typography
          id="alert-dialog-description"
          className={classes.descriptionText}
        >
          {t("recommendation_warning_2")}
        </Typography>
        <DialogActions className={classes.buttonBar}>
          <Button
            onClick={() => {
              closeDialog();
            }}
            color="default"
            variant="contained"
            className={classes.dialogButtons}
          >
            {t("no")}
          </Button>
          <Button
            onClick={handleSubmit}
            color="primary"
            variant="contained"
            className={classes.dialogButtons}
          >
            {t("yes")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default RecommendationWarningDialog;

export interface iProps {
  toggle: boolean;
  unit_id: string;
  reportDate: Date;
  userLanguage: string | null | undefined;
  onClose: () => void;
  setDialogOpen: Dispatch<SetStateAction<boolean>>;
}
